import { type CustomCellEditorProps, DatePicker } from '@uturn/ui-kit';
import { type FC, useState } from 'react';
import { useTranslation } from 'react-i18next';

type Props = CustomCellEditorProps;

const DateTimePickerEditor: FC<Props> = ({
	value,
	onValueChange,
	api,
	rowIndex,
	column,
}) => {
	const { t } = useTranslation();
	const [date, setDate] = useState<Date | null>(value ? new Date(value) : null);

	const onChangeHandler = (dateValue: Date | null) => {
		setDate(dateValue);
		onValueChange(dateValue);
	};

	const onCalenderCloseHandler = () => {
		api.stopEditing();
		api.setFocusedCell(rowIndex, column.getColId());
	};

	return (
		<DatePicker
			className="ag-custom-component-popup"
			placeholderText={t('general.date', 'Choose a date') ?? undefined}
			value={date ?? undefined}
			selected={date ?? undefined}
			defaultOpen={true}
			type="datetime"
			onSelect={(v) => onChangeHandler(v ?? null)}
			onCloseHandler={onCalenderCloseHandler}
		/>
	);
};

export default DateTimePickerEditor;
